// extracted by mini-css-extract-plugin
export var activeDot = "_2w-c";
export var buttonContainer = "_2w-9";
export var channelButton = "_2w-a";
export var clickable = "_2w-d";
export var content = "_2w-0";
export var contentFull = "_2w-2";
export var contentThird = "_2w-1";
export var contentWrapper = "_2w-7";
export var description = "_2w-5";
export var heightShort = "_2w-f";
export var image = "_2w-3";
export var imageContainer = "_2w-4";
export var selectButton = "_2w-e";
export var spinnerContainer = "_2w-b";
export var titleContent = "_2w-8";
export var titleWrapper = "_2w-6";